// extracted by css-extract-rspack-plugin
export default {"queryButton":"cVbiz IXEGd _Uhde","queryButtonText":"PjWgx SJXBn"};